import { getPrincipal } from "@/principal";
import { type QueryKey } from "@tanstack/react-query";

// Type alias for clarity
export type PrincipalKey = string;

export function serviceAccountPrincipalKey(serviceAccountId: string): PrincipalKey {
    return `sa/${serviceAccountId}`;
}

export function keyWithPrincipal(key: QueryKey, principal?: PrincipalKey): QueryKey {
    return ["principal", principal || getPrincipal(), ...key];
}
